import { c as _c } from "react/compiler-runtime";
import { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import React from "react";
import SecondaryButton from "../utils/button/SecondaryButton";
import { SingleWaveDropVote } from "../waves/drop/SingleWaveDropVote";
import ModalLayout from "../waves/memes/submission/layout/ModalLayout";
interface VotingModalProps {
  readonly drop: ExtendedDrop;
  readonly isOpen: boolean;
  readonly onClose: () => void;
}
const VotingModal: React.FC<VotingModalProps> = t0 => {
  const $ = _c(16);
  const {
    drop,
    isOpen,
    onClose
  } = t0;
  if (!isOpen) {
    return null;
  }
  let t1;
  if ($[0] !== onClose) {
    t1 = <div className="tw-fixed tw-inset-0" onClick={onClose} aria-hidden="true" />;
    $[0] = onClose;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== drop || $[3] !== onClose) {
    t2 = <SingleWaveDropVote drop={drop} onVoteSuccess={onClose} />;
    $[2] = drop;
    $[3] = onClose;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== onClose) {
    t3 = <div className="tw-mt-4 tw-flex tw-justify-end"><SecondaryButton onClicked={onClose}>Cancel</SecondaryButton></div>;
    $[5] = onClose;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t2 || $[8] !== t3) {
    t4 = <div className="tw-pb-6 tw-pt-1">{t2}{t3}</div>;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== onClose || $[11] !== t4) {
    t5 = <div className="tw-w-full tw-max-w-2xl tw-z-10" onClick={_temp2}><ModalLayout title="Vote for this artwork" onCancel={onClose}>{t4}</ModalLayout></div>;
    $[10] = onClose;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t1 || $[14] !== t5) {
    t6 = <div className="tw-fixed tw-inset-0 tw-bg-gray-600 tw-bg-opacity-50 tw-backdrop-blur-[1px] tw-z-50 tw-flex tw-items-center tw-justify-center" onClick={_temp}>{t1}{t5}</div>;
    $[13] = t1;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
};
export default VotingModal;
function _temp(e) {
  return e.stopPropagation();
}
function _temp2(e_0) {
  return e_0.stopPropagation();
}